module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-004"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XIII",
      "title": "XIII"
    }
  }, [_c('h1', {
    staticClass: "pre_surtit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "",
      "id": "fig-007",
      "src": "images/fig_5.jpg"
    }
  })])]), _c('p', {
    staticClass: "auteur"
  }, [_c('img', {
    staticClass: "image_intext",
    attrs: {
      "alt": "Illustration",
      "id": "fig-005_2",
      "src": "images/BG_block_paul_color.jpg"
    }
  })]), _c('div', {
    staticClass: "dev"
  }, [_c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tableau-001"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    staticStyle: {
      "border-collapse": "collapse",
      "border-spacing": "0px"
    }
  }, [_c('colgroup', {
    staticStyle: {
      "padding": "7px"
    }
  }, [_c('col', {
    staticStyle: {
      "width": "16%"
    }
  }), _c('col', {
    staticStyle: {
      "padding": "7px"
    }
  })]), _c('tbody', [_c('tr', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("BJ")])])]), _c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Dunn, James D. G. "), _c('i', [_vm._v("Christianity in the Making")]), _vm._v(". Vol. 2, "), _c('i', [_vm._v("Beginning from Jerusalem")]), _vm._v(". Grand Rapids: Eerdmans, 2008.")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("NPP")])])]), _c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Dunn, James D. G. "), _c('i', [_vm._v("The New Perspective on Paul: Whence, What, and Whither")]), _vm._v(". Rev. ed. Grand Rapids, Eerdmans, 2005.")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("OMSP")])])]), _c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Gaventa, Beverly Roberts. "), _c('i', [_vm._v("Our Mother Saint Paul")]), _vm._v(". Louisville: Westminster John Knox, 2007.")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("PALLT")])])]), _c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Sanders, E. P. "), _c('i', [_vm._v("Paul: The Apostle’s Life, Letters, and Thought")]), _vm._v(". Minneapolis: Fortress, 2016.")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("PFG")])])]), _c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Wright, N. T. "), _c('i', [_vm._v("Paul and the Faithfulness of God")]), _vm._v(". 2 vols. Christian Origins and the Question of God 4. Minneapolis: Fortress, 2013.")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("PLJP")])])]), _c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Sanders, E. P. "), _c('i', [_vm._v("Paul, the Law, and the Jewish People")]), _vm._v(". Minneapolis: Fortress, 1983.")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("PPJ")])])]), _c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Sanders, E. P."), _c('i', [_vm._v(" Paul and Palstinian Judaism. ")]), _vm._v("Philadelphia: Fortress, 1977.")])])]), _c('tr', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("TPA")])])]), _c('td', {
    staticStyle: {
      "padding": "7px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Dunn, James D. G. "), _c('i', [_vm._v("The Theology of the Paul the Apostle")]), _vm._v(". Grand Rapids: Eerdmans, 1998.")])])])])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30ed1363","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre4.vue
// module id = 72
// module chunks = 0